import React from 'react';
import { Quote } from 'components/quote/Quote';
import { Author } from 'components/author/Author';
import { Divider } from 'components/elements/divider/Divider';

export const Component = () => {
  const quoteContent = (
    <>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna tempor
        blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem. Vestibulum sit
        amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien enim, accumsan dictum
        blandit eu, dictum vel felis. Ut at justo ornare augue auctor maximus. Donec cursus egestas
        nisl laoreet bibendum. Maecenas in nunc vitae neque sodales molestie. Phasellus euismod arcu
        quis pharetra condimentum. Aenean gravida magna ac quam accumsan sodales.
      </p>
      <p>
        Maecenas porttitor, mi a vulputate luctus, turpis tellus luctus nisi, sed pretium mauris dui
        ut metus. Sed vulputate nibh eros, pellentesque pharetra dui ultricies vulputate. Cras ac
        elit tempus, egestas est vitae, laoreet ante. Donec commodo massa vitae imperdiet tincidunt.
        Proin consectetur, massa in tristique efficitur, nunc est finibus orci, eu cursus ipsum
        dolor quis tellus. Mauris erat metus, efficitur eget tempor eget, tristique ac purus.
        Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis
        egestas.
      </p>
    </>
  );

  return (
    <>
      <Divider>Quote with attribution</Divider>
      <Quote
        isSlice
        text={quoteContent}
        attribution={
          <Author
            name="Author Name"
            position="Author Information"
            imageComponent={<img src="/static/images/signature.png" width="182" height="94" />}
          />
        }
      />
      <Divider>Quote without attribution</Divider>
      <Quote isSlice text={quoteContent} />
    </>
  );
};
